import script from "./terminal-blocking-ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./terminal-blocking-ranking-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__